import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=864dfe94&"
import script from "./Flags.vue?vue&type=script&lang=js&"
export * from "./Flags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports